import { Text, Container, Title, createStyles, Button, Flex, Paper, Grid, Image, rem } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  imageWrapper: {
    position: "relative",

    [theme.fn.smallerThan("sm")]: {
      padding: theme.spacing.lg,
    },
  },

  image: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -40%)",

    [theme.fn.smallerThan("sm")]: {
      position: "static",
      transform: "translate(0, 0)",
    },
  },

  content: {
    padding: theme.spacing.lg,
    gap: theme.spacing.lg,
    fontSize: theme.fontSizes.md,

    [theme.fn.largerThan("sm")]: {
      fontSize: theme.fontSizes.xl,
      paddingTop: `calc(${theme.spacing.md} * 7)`,
      paddingBottom: `calc(${theme.spacing.md} * 7)`,
      paddingRight: `calc(${theme.spacing.md} * 4)`,
      paddingLeft: `calc(${theme.spacing.md} * 4)`,
      gap: `calc(${theme.spacing.xl} * 2)`,
    },
  },

  inner: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 700,
    fontSize: "3rem",
    marginBottom: 48,

    [theme.fn.smallerThan("md")]: {
      fontSize: "2.5rem",
      marginBottom: 32,
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: "2rem",
      marginBottom: 24,
    },
  },

  highlight: {
    position: "relative",
    color: theme.white,
    background: theme.fn.variant({ variant: "gradient", gradient: { from: "orange", to: "red" } }).background,
    borderRadius: theme.radius.sm,
    padding: `${rem(4)} ${rem(12)}`,
    lineHeight: rem(72),
  },
}))

// ----------------------------------------------------------------------

export function Licence(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size="xl" className={classes.inner}>
      <Title className={classes.title} maw={768}>
        <span className={classes.highlight}>Почему</span> нам доверяют более 10000 студентов?
      </Title>

      <Paper bg="indigo.8" radius="xl">
        <Grid align="center" justify="center" gutter={0} p={0}>
          <Grid.Col xs={12} sm={6} order={2} orderSm={1}>
            <Flex direction="column" align="flex-start" className={classes.content}>
              <Text color="white" fw={600}>
                Наша организация осуществляет образовательную деятельность на основании{" "}
                <Text span color="orange">
                  государственной лицензии
                </Text>{" "}
                и выдает документы установленного образца.
              </Text>
              <Button
                component="a"
                target="_blanck"
                href="https://islod.obrnadzor.gov.ru/rlic/details/fc0ce866-2c42-f41f-cee1-67bd2a3787e2/"
                variant="white"
                color="dark"
                radius="lg"
                size="lg"
              >
                Проверить лицензию
              </Button>
            </Flex>
          </Grid.Col>
          <Grid.Col xs={12} sm={6} order={1} orderSm={2} className={classes.imageWrapper}>
            <Image className={classes.image} src="assets/licence.png"/>
          </Grid.Col>
        </Grid>
      </Paper>
    </Container>
  )
}
